export default "__VITE_ASSET__CD80qDJ4__"